import React, { Component, PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

class CoverType extends Component {

  constructor(props) {
    super(props);
    this.state = {
      option: [],
      isDataLoaded: false
    }
  }

  componentWillMount() {

  }

  render() {
    return (
      <FormGroup controlId="coverType">
        <Col componentClass={ControlLabel} sm={5}>
          Cover Type
        </Col>
        <Col sm={7}>
                <select
                  className="custom-select"
                  id="coverType"
                  onChange={this.props.handleChangeCoverType}
                  value={this.props.coverType}
                  required
                >
                  <option value="">Please select</option>
                  <option value="comprehensive">Comprehensive</option>
                  <option value="thirdParty">Third Party</option>
                </select>
        </Col>
      </FormGroup>
    )
  }
}

CoverType.propTypes = {
  handleChangeCoverType: PropTypes.func,
  coverType: PropTypes.string
};

export default CoverType;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/coverType/CoverType.js